import React from 'react';
import PropTypes from 'prop-types';

const NumberPicker = ({ current, max, update }) => {
  const decrease = () => update(Math.max(1, current - 1));
  const increase = () => update(Math.min(max, current + 1));
  return (
    <div className="number-picker">
      <input
        type="submit"
        value="–"
        onClick={decrease}
        disabled={current <= 1}
      />
      <div className="value">{current}</div>
      <input
        type="submit"
        value="+"
        onClick={increase}
        disabled={current === max}
      />
    </div>
  );
};
NumberPicker.propTypes = {
  current: PropTypes.number,
  max: PropTypes.number,
  update: PropTypes.func,
};

export default NumberPicker;



// WEBPACK FOOTER //
// ./src/components/number-picker.js